import React from 'react'

import CertificadoDigitalFormPageContainer from './CertificadoDigitalFormPageContainer'

export class CertificadoDigitalFormPage extends React.Component {
  render() {
    return <CertificadoDigitalFormPageContainer {...this.props} />
  }
}
